import { useButton } from '@react-aria/button';
import React__default from 'react';
import { useSwanPopover } from './popover.context.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function PopoverTrigger(_ref) {
  var children = _ref.children;

  var _useSwanPopover = useSwanPopover(),
      triggerRef = _useSwanPopover.triggerRef,
      _useSwanPopover$trigg = _useSwanPopover.triggerProps,
      triggerProps = _useSwanPopover$trigg === void 0 ? {} : _useSwanPopover$trigg;

  var _useButton = useButton(triggerProps, triggerRef),
      buttonProps = _useButton.buttonProps;

  var props = _object_spread_props(_object_spread({
    ref: triggerRef
  }, buttonProps), {
    type: undefined
  }); // Axe tests will yell if aria-expanded has a value of "false"


  if (!buttonProps['aria-expanded']) {
    delete props['aria-expanded'];
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, React__default.Children.map(children, function (child, index) {
    if (index === 0 && /*#__PURE__*/React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.cloneElement( // eslint-disable-next-line @typescript-eslint/no-explicit-any
      child, props);
    }

    return child;
  }));
}

export { PopoverTrigger };